import { render } from "./Walls.vue?vue&type=template&id=f7ce8388&scoped=true&lang=html"
import script from "./Walls.vue?vue&type=script&lang=js"
export * from "./Walls.vue?vue&type=script&lang=js"

import "./Walls.vue?vue&type=style&index=0&id=f7ce8388&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7ce8388"]])

export default __exports__